import { createWebHistory, createRouter, RouteRecordRaw } from 'vue-router';
import SocketConnectionLayout from '@/layouts/SocketConnection/index.vue';
import store from '@/store';
import { adminAccess } from './adminAccess';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: SocketConnectionLayout,
    children: [
      {
        path: '',
        name: 'start',
        component: () => import('../pages/Start/index.vue'),
      },
      {
        path: '/conversation/:convoId?',
        name: 'conversation',
        component: () => import('../pages/Conversation/index.vue'),
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('../pages/ResetPassword/index.vue'),
      },
      {
        path: '/admin',
        component: () => import('../pages/Admin/index.vue'),
        // Guarding the parent, so every section added later is gated by default
        // rather than depending on whoever adds it remembering to guard it.
        // The server checks admin rights on every event regardless; this only
        // keeps the page from rendering for someone who cannot use it.
        beforeEnter: (to, from, next) => {
          const access = adminAccess(store.getters['chat/me'], store.getters['chat/isMeResolved']);
          if (access === 'deny') {
            next({ name: 'start' });
            return;
          }

          next();
        },
        children: [
          { path: '', redirect: { name: 'admin-whitelist' } },
          {
            path: 'whitelist',
            name: 'admin-whitelist',
            component: () => import('../pages/Admin/sections/Whitelist/index.vue'),
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
